module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/works.json
// module id = 336
// module chunks = 137129094186034